<template>
  <div class="pa-0 ma-0">
    <v-data-table
      :headers="headers"
      :items="providers"
      :hide-default-footer="true"
      :no-data-text="$t('Generic.No_Data')"
      class="elevation-0"
      dense
    >
      <template v-slot:item.name="{ item }">
        <v-text-field
          :placeholder="$t('Generic.Name')"
          v-model="item.name"
          :rules="[v => !!v || $t('Rules.Name_required')]"
        ></v-text-field>
      </template>

      <template v-slot:item.stationId="{ item }">
        <v-text-field
          :placeholder="$t('Manage_Sites.StationId')"
          v-model="item.stationId"
          :rules="[v => !!v || $t('Rules.StationId_required')]"
        ></v-text-field>
      </template>

      <template v-slot:item.inverterId="{ item }">
        <v-text-field
          :placeholder="$t('Manage_Sites.InverterId')"
          v-model="item.inverterId"
          :rules="[v => !!v || $t('Rules.InverterId_required')]"
        ></v-text-field>
      </template>

      <template v-slot:item.accessId="{ item }">
        <v-autocomplete
          v-model="item.accessId"
          :items="accesses"
          :label="$t('Manage_Sites.FusionSolar_Access')"
          item-text="userName"
          item-value="id"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.Actions="{ item }">
        <v-btn
          text
          icon
          color="red"
          class="ma-0 pa-0"
          v-on:click="removeProvider(item)"
        >
          <v-icon class="ma-0 pa-0">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-btn class="mt-2" rounded depressed small v-on:click="addProvider">
      <v-icon color="primary" class="pr-1">mdi-plus</v-icon>
      {{ $t("Manage_Sites.SiteProvidersTable.AddProvider") }}
    </v-btn>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        {
          text: this.$i18n.t("Generic.Name"),
          align: "left",
          value: "name",
          sortable: false
        },
        {
          text: this.$i18n.t("Manage_Sites.StationId"),
          align: "left",
          value: "stationId",
          sortable: false
        },
        {
          text: this.$i18n.t("Manage_Sites.InverterId"),
          align: "left",
          value: "inverterId",
          sortable: false
        },
        {
          text: this.$i18n.t("Manage_Sites.FusionSolar_Access"),
          align: "left",
          value: "accessId",
          sortable: false
        },
        {
          text: this.$i18n.t("Generic.Actions"),
          value: "Actions",
          align: "center",
          sortable: false,
          width: "10%"
        }
      ]
    };
  },
  props: {
    providers: Array,
    accesses: Array
  },
  methods: {
    removeProvider(provider) {
      const index = this.providers.indexOf(provider);
      if (index !== -1) {
        this.providers.splice(index, 1);
      }
    },
    addProvider() {
      this.providers.push({
        name: "",
        stationId: "",
        inverterId: "",
        accessId: ""
      });
    }
  }
};
</script>
